import { useRouter } from 'next/router';

import { useConfig } from '@packages/utilities';

import { cleanupCategoryPath } from '../utils/categoryPaths';

/**
 * Get the category path with a language prefix if the current language differs from the default language
 *
 * May also strip the trailing slash from the path depending on next.config.ts
 *
 * @example jelmolich
 * /herren/mode/jacken/ -> /herren/mode/jacken
 * /homme/mode/vestes/ -> /fr/homme/mode/vestes
 */
export const useCleanCategoryPathname = () => {
  const {
    i18n: { defaultLocale },
  } = useConfig();

  const { asPath: pathWithoutLanguagePrefix, locale: language } = useRouter();

  const localizedCategoryPath = `${
    language && !defaultLocale.startsWith(language) ? `/${language}` : ''
  }${pathWithoutLanguagePrefix}`;

  return cleanupCategoryPath(localizedCategoryPath);
};
